import styled, { css } from 'styled-components';

export const ModalContainer = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
 `}
`;

export const ModalStep = styled.div`
  ${({ theme, step }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100vh;
    max-width: 100vw;
    overflow: hidden auto;

    ${step === 'step-2' && css`
      padding-bottom: 135px;
    `}

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding-left: 
    }
  `}
`;

export const Content = styled.div`
  ${({ theme, step }) => css`
    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 40px 24px 0;
    }

    ${step === 'step-3' && css`
      align-items: center;
      display: flex;
      flex-direction: column;
      margin: auto;
      padding-bottom: 10%;
      
      @media (max-width: ${theme.v2.breakpoints.md}) {
        padding: 40px 24px 15vh;
      }
    `}
 `}
`;

export const ModalTitleContainer = styled.div`
  ${({ theme, isProPlan }) => css`
    align-items: center;
    background: ${isProPlan ? theme.v2.colors.gradient.secondary : theme.v2.colors.gradient.primary};
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 24px 48px;
    position: relative;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 20px 20px 17px;
    }
 `} 
`;

export const Column = styled.div`
  ${({ theme, align, type }) => css`
    display: flex;
    gap: 16px;
    justify-content: ${align || 'flex-start'};
    
    @media (min-width: ${theme.v2.breakpoints.md}) {
      flex: 1;
    }

    ${type === 'studioTitle' && css`
      @media (max-width: ${theme.v2.breakpoints.md}) {
        margin: 0 auto;
        order: 1;
      }
    `}

    ${type === 'logoBuilder' && css`
      @media (max-width: ${theme.v2.breakpoints.md}) {
        order: 3;
        width: 100%;
      }
    `}

    ${type === 'button' && css`
      @media (max-width: ${theme.v2.breakpoints.md}) {
        order: 2;
      }
    `}
  `}
`;

export const WrapperButtonGoStudio = styled.div`
  button {
    padding: 3px;
  }
`;

export const WrapperStudioTitle = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
`;

export const StudioTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.white.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 150%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ModalTitle = styled.h4`
  ${({ theme }) => css`
    color: ${theme.v2.colors.white.primary};
    flex: 1;
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 150%;
    margin: 0;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
      padding-right: 0;
    }
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.gradient.secondary};
    width: 100%;
  `}
`;

export const WrapperTitle = styled.div`
  ${({ theme, step }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;

    ${step === 'step-loading' && css`
      margin: 166px 0 44px;
      
      @media (max-width: ${theme.v2.breakpoints.md}) {
        margin: 32px 0 24px;
      }
    `}

    ${step === 'step-1' && css`
      gap: 24px;
      margin: 65px 0 24px;
      
      @media (max-width: ${theme.v2.breakpoints.md}) {
        gap: 16px;
        margin: 32px 0 20px;
      }
    `}

    ${step === 'step-2' && css`
      gap: 8px;
      margin: 80px 0 60px;
      
      @media (max-width: ${theme.v2.breakpoints.md}) {
        gap: 16px;
        margin: 32px 0;
      }
    `}
  `}
`;

export const LogoBuilderTitle = styled.div`
  ${({ theme, isProPlan }) => css`
    background: ${isProPlan ? theme.v2.colors.gradient.secondary : theme.v2.colors.gradient.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 1.3;
    text-align: center;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const ModalSubtitle = styled.h5`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    margin: 0;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
      margin-bottom: 20px;
    }
  `}
`;

export const ModalDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 150%;
    margin: 16px 0 22px 0;
    max-width: 768px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
      margin: 8px 8px 20px 8px;
    }
  `}
`;

export const TellUsTitle = styled.h5`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 150%;
    margin: 0 0 24px 0;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
      margin: 0 0 14px 0;
    }
  `}
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 672px;
  width: 100%;
`;

export const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    justify-content: center;
    margin-top: 48px;
    padding-bottom: 24px;
    max-width: 672px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin-top: 32px;
    }
  `}
`;

export const CreditsInfo = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 48px;
    justify-content: center;
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xs};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
    
    svg {
      height: 16px;
      width: 16px;

      @media (max-width: ${theme.v2.breakpoints.md}) {
        height: 12px;
        width: 12px;
      }
    }
  `}
`;

export const Credits = styled.div`
  ${({ theme }) => css`
  position: absolute;
  right: 40px;
  top: calc(100% + 32px);

  @media (max-width: ${theme.v2.breakpoints.md}) {
    right: 24px;
    top: calc(100% + 24px);
  }
  `}
`;

export const CreditsContent = styled.div`
  ${({ theme }) => css`
    align-items: center;
    border-radius: 60px;
    background: ${theme.v2.colors.gradient.primary};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 8px;
    height: 40px;
    justify-content: center;
    line-height: 16px;
    margin: 0;
    padding: 16px;
    position: relative;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 60px;
      padding: 1px;
      background: ${theme.v2.colors.gradient.primary};
      -webkit-mask: 
        linear-gradient(#fff 0 0) content-box, 
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      pointer-events: none;
    }
  `}
`;

export const ErrorMessage = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.feedback.problemMedium};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 150%;
    margin: 46px 0 -16px 0;
    text-align: center;
  `}
`;

export const ChooseColor = styled.h5`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    margin: 0;
    margin-top: 40px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
      margin-top: 24px;
    }
  `}
`;

export const CustomColor = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
`;

export const LoadingWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const LoadingText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 150%;
    margin: 0;
    text-align: center;
  `}
`;

export const WrapperListLogos = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: 48px;
    justify-content: center;
    margin-bottom: 60px;
    max-width: 888px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      gap: 40px 22px;
    }
  `}
`;

export const WrapperLogo = styled.div`
  ${({ theme, isLoading }) => css`
    border-radius: 16px;
    
    ${isLoading && css`
      align-items: center;
      display: flex;
      height: 264px;
      background: linear-gradient(180deg, #D1E6FD 0%, #F3F9FF 100%);
      border: 1px solid ${theme.v2.colors.neutral.highLight};
      justify-content: center;
      width: 264px;

      @media (max-width: ${theme.v2.breakpoints.md}) {
        height: 148px;
        width: 148px;
      }
    `}
  `}
`;

export const WrapperImage = styled.div`
  ${({ theme }) => css`
    border-radius: 24px;
    height: 264px;
    overflow: hidden;
    position: relative;
    width: 264px;

    svg {
      height: auto;
      left: 50%;
      max-width: 100%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 148px;
      width: 148px;
    }
  `}
`;

export const LogoLoading = styled.div`
  ${({ theme }) => css`
    height: 48px;
    width: 48px;

    img {
      max-width: 100%;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 28px;
      width: 28px;
    }
  `}
`;

export const BoxRetry = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
`;

export const WrapperTextRetry = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
  justify-content: center;
  width: 100%;
`;

export const TextRetry = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: 1.5;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      max-width: 270px;
      text-align: center;
    }
  `}
`;

export const LogoActions = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 16px;

  button {
    padding: 7px;
  }
`;

export const BoxNoCredits = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: center;
    margin: 28px auto 0;
    max-width: 608px;
    padding: 48px 48px 32px;
    position: relative;

    button {
      background-color: transparent;
    }
  `}
`;

export const IconBoxNoCredits = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.gradient.secondary};
    box-shadow: 0 0 0 6px ${theme.v2.colors.white.primary};
    border-radius: 16px;
    left: 50%;
    line-height: 0;
    padding: 12px;
    position: absolute;
    top: -24px;
    transform: translateX(-50%);
  `}
`;

export const TextBoxNoCredits = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: 1.5;
    text-align: center;
    padding: 0 22px;
  `}
`;

export const ActionBoxNoCredits = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  width: 100%;
`;

export const TitleError = styled.div`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowLight};
    display: flex;
    flex-direction: column;
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 24px;
    justify-content: center;
    line-height: 1.5;
    margin-bottom: 24px;
    text-align: center;
  `}
`;
